import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap'
import Label from "components/general/Label"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { useGetNocs } from 'helpers/commonCodes';
import Noc from 'components/presentation/Noc';




export default function SelectorMedal({ page = "" }) {
    let params = useUrlFriendlyToParameters()
    const [paramsUrl, setParamsUrl] = useState({});
    const [shouldNavigate, setShouldNavigate] = useState(false);
    useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, page)



    //copy parameters URL to change 
    let paramsURL = { ...params }
    //Change object if make changes over params make changes in componets related   
    if (paramsURL['mirs_competition'] === undefined) {
        paramsURL['mirs_competition'] = process.env.REACT_APP_DEFAULT_COMPETITION
    }

    if (paramsURL['mirs_language'] === undefined) {
        paramsURL['mirs_language'] = process.env.REACT_APP_DEFAULT_LANGUAGE
    }

    paramsURL["mirs_medal"] = "";




    //Go to schedule 
    const handleOnChange = (key) => {
        paramsURL["mirs_medal"] = key
        setParamsUrl(paramsURL);
        setShouldNavigate(true);
    };

    return (

        <Dropdown onSelect={handleOnChange} id="selectorMedals" className={"selectorContainer"} >
            <Dropdown.Toggle variant="success" id="dropdown-basic">
                <Label data={'LabelMedals'} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item key="Selector-Medal-all" eventKey="" >
                    <Label data={'LabelAllMedals'} />
                </Dropdown.Item>
                <Dropdown.Item key={"Selector-Medal-1"} eventKey={"1"} >
                    <div className="itemMedal justify-content-left">
                        <Label data={"LabelMedalDesc1"} />
                    </div>
                </Dropdown.Item>
                <Dropdown.Item key={"Selector-Medal-2"} eventKey={"2"} >
                    <div className="itemMedal justify-content-left">
                        <Label data={"LabelMedalDesc2"} />
                    </div>
                </Dropdown.Item>
                <Dropdown.Item key={"Selector-Medal-3"} eventKey={"3"} >
                    <div className="itemMedal justify-content-left">
                        <Label data={"LabelMedalDesc3"} />
                    </div>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>


    );
};


const ItemMedal = (props) => {
    const { mirs_competition } = useUrlFriendlyToParameters()
    let competition = mirs_competition;
    const [showImage, setShowImage] = useState(true);
    const hideImg = (event) => {
        // this.setState({ showImg: false });
        setShowImage(true);
    };
    let labelcode = "LabelMedalDesc" + props
    props.nocnode.showLongDesc = true;
    return (
        <div className="itemMedal justify-content-left">
            <label data={labelcode} />
        </div>
    )
};